export const MOBILE_UPDATE_ACTION = 'MOBILE_UPDATE_ACTION';
export const MOBILE_UPDATE_SUCCESS_ACTION = 'MOBILE_UPDATE_SUCCESS_ACTION';
export const MOBILE_UPDATE_FAILURE_ACTION = 'MOBILE_UPDATE_FAILURE_ACTION';
